import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  CreateBusinessUnitRequest,
  CreateBusinessUnitResponse,
  DeleteBusinessUnitRequest,
  DeleteBusinessUnitResponse,
  GetBusinessUnitRequest,
  GetBusinessUnitResponse,
  ListBusinessUnitRequest,
  ListBusinessUnitResponse,
  UpdateBusinessUnitRequest,
  UpdateBusinessUnitResponse,
} from 'src/types/orbit/BusinessUnit';

export const businessUnitService = {
  getAll: (data: ListBusinessUnitRequest) => {
    return apiClient.get<ListBusinessUnitResponse>(
      ServiceType.ORBIT,
      createApiUrl(API_ENDPOINTS.ORBIT_SERVERICE.BUSINESS_UNIT.ALL(data.programId)),
      data,
    );
  },

  get: (data: GetBusinessUnitRequest) => {
    return apiClient.get<GetBusinessUnitResponse>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.BUSINESS_UNIT.GET(
          data.programId,
          data.businessUnitId,
        ),
      ),
      data,
    );
  },
  update: (data: UpdateBusinessUnitRequest) => {
    return apiClient.put<UpdateBusinessUnitResponse, UpdateBusinessUnitRequest>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.BUSINESS_UNIT.UPDATE(
          data.programId,
          data.businessUnitId,
        ),
      ),
      data,
    );
  },

  delete: (data: DeleteBusinessUnitRequest) => {
    return apiClient.delete<DeleteBusinessUnitResponse>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.BUSINESS_UNIT.DELETE(
          data.programId,
          data.businessUnitId,
        ),
      ),
      data,
      data.deletedBy,
    );
  },

  create: (data: CreateBusinessUnitRequest) => {
    return apiClient.post<CreateBusinessUnitResponse, CreateBusinessUnitRequest>(
      ServiceType.ORBIT,
      createApiUrl(API_ENDPOINTS.ORBIT_SERVERICE.BUSINESS_UNIT.CREATE(data.programId)),
      data,
    );
  },
};
